import React from 'react';
import { SubRouterProps } from '../shared/types';
import { DefaultLayout } from '../shared/layouts';
import { Router } from './components';

// Point d'entrée du module catalogue
const Catalogue: React.FC<SubRouterProps> = ({ sourceStructureNode, ...rest }: SubRouterProps) => {
    return (
        <DefaultLayout>
            <Router {...rest} sourceStructureNode={sourceStructureNode} />
        </DefaultLayout>
    );
};

export default Catalogue;
